import apiClient from './apiClient';

interface EmergencyQuery {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  priority?: string;
  type?: string;
}

interface EmergencyResponse {
  emergencies: any[];
  total: number;
  stats: {
    active: number;
    resolved: number;
    cancelled: number;
  };
}

class EmergencyService {
  async getEmergencies(params: EmergencyQuery): Promise<EmergencyResponse> {
    const response = await apiClient.get('/emergency/alerts', { params });
    return response.data;
  }

  async getEmergencyById(id: number): Promise<any> {
    const response = await apiClient.get(`/emergency/alerts/${id}`);
    return response.data;
  }

  async resolveEmergency(id: number): Promise<void> {
    await apiClient.put(`/emergency/alerts/${id}/resolve`);
  }

  async cancelEmergency(id: number): Promise<void> {
    await apiClient.put(`/emergency/alerts/${id}/cancel`);
  }

  async updateEmergency(id: number, data: any): Promise<any> {
    const response = await apiClient.put(`/emergency/alerts/${id}`, data);
    return response.data;
  }

  async getEmergencyHistory(id: number): Promise<any[]> {
    const response = await apiClient.get(`/emergency/alerts/${id}/history`);
    return response.data;
  }

  async exportEmergencies(params: EmergencyQuery): Promise<Blob> {
    const response = await apiClient.get('/emergency/alerts/export', {
      params,
      responseType: 'blob',
    });
    return response.data;
  }
}

export const emergencyService = new EmergencyService();
